import { render, staticRenderFns } from "./listaspromotor.vue?vue&type=template&id=f12a8fc2&scoped=true&"
import script from "./listaspromotor.vue?vue&type=script&lang=js&"
export * from "./listaspromotor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f12a8fc2",
  null
  
)

export default component.exports